<template>
  <div raised>
    <v-list two-line subheader>
      <v-list-tile style="list-style-type: none;" avatar @click.stop="">
        <v-list-tile-avatar>
          <img :src="picture" />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ file.name }}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn :disabled="uploaded" @click.native.stop="startUpload" icon ripple>
            <v-icon v-if="!progress" color="grey lighten-1">cloud_upload</v-icon>
            <v-icon v-else-if="uploaded">cloud_done</v-icon>
            <v-icon v-else-if="progress < 0" color="red lighten-1">cloud_off</v-icon>
            <v-progress-circular
              v-else
              :size="40"
              :width="2"
              :rotate="360"
              :value="progress"
              color="teal">
              {{ progress }}
            </v-progress-circular>
          </v-btn>
        </v-list-tile-action>
        <v-list-tile-action>
          <v-btn @click.native.stop="remove" icon ripple>
            <v-icon color="grey lighten-1">close</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-progress-linear :value="uploading"/>
    </v-list>
  </div>
</template>

<script>
import { auth, storage } from '@/firebase'

export default {
  props: {
    file: {
      type: File,
      required: true,
    },
  },
  data() {
    return {
      picture: null,
      uploading: null,
    };
  },
  computed: {
    progress() {
      return Math.round(this.uploading);
    },
    uploaded() {
      return this.progress >= 100;
    },
  },
  mounted() {
    const reader = new FileReader();
    reader.onload = (e) => {
        console.log(e)
        this.picture = e.target.result
    };
    reader.readAsDataURL(this.file);
    console.log(this.file)
  },
  methods: {
    remove() {
      this.$emit('remove', this.file);
    },
    upload() {
      if (!this.uploaded) {
        this.startUpload();
      }
    },
    startUpload() {
        this.uploading = 0.1;
        const metadata = {
            cacheControl: 'public,max-age=3600',
            contentType: this.file.type,
            customMetadata: {
            owner: auth.currentUser.uid,
            },
        };
        const upload = storage
            .ref(`users/${auth.currentUser.uid}/files/${this.file.name}`)
            .put(this.file, metadata);
        upload.on('state_changed', (snapshot) => {
            this.uploading = ((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
        }, (err) => {
            this.uploading = -1
        }, (res) => {
            this.file.ref = `users/${auth.currentUser.uid}/files/${this.file.name}`;
            this.file.url = upload.snapshot.downloadURL;
            this.uploading = 100;
            this.$emit('uploaded', this.file);
        })
    }
  },
};
</script>